import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckIcon from '@material-ui/icons/Check';
import { GUOMEI, payment } from '../guomeiContent';
import { copyText } from '../copyText';

const Payment = () => {
  const [copiedKey, setCopiedKey] = useState('');

  const handleCopy = async (key, value) => {
    try {
      await copyText(value);
      setCopiedKey(key);
      window.setTimeout(() => {
        setCopiedKey((current) => (current === key ? '' : current));
      }, 1800);
    } catch (err) {
      // clipboard may be blocked
    }
  };

  return (
    <Box
      component="section"
      id="pago"
      py={{ xs: 7, md: 10 }}
      px={{ xs: 2.5, sm: 4, md: 7 }}
      bgcolor={GUOMEI.white}
    >
      <Box maxWidth={1100} mx="auto">
        <Typography
          sx={{
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            color: GUOMEI.lagoon,
            mb: 1.25,
          }}
        >
          {payment.overline}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontFamily: '"Fraunces", "Georgia", serif',
            fontWeight: 700,
            fontSize: { xs: '1.85rem', md: '2.55rem' },
            color: GUOMEI.ink,
            mb: 1.25,
          }}
        >
          {payment.title}
        </Typography>
        <Typography
          sx={{
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            color: GUOMEI.inkMuted,
            fontSize: { xs: '1.05rem', md: '1.12rem' },
            lineHeight: 1.65,
            maxWidth: 560,
            mb: { xs: 4, md: 5 },
          }}
        >
          {payment.subtitle}
        </Typography>

        <Grid container spacing={2.5}>
          {payment.methods.map((method) => (
            <Grid item xs={12} sm={6} md={4} key={method.id}>
              <Box
                p={{ xs: 2.5, md: 3 }}
                borderRadius={2}
                border={`1px solid ${GUOMEI.sandDeep}`}
                bgcolor={GUOMEI.sand}
                height="100%"
              >
                <Typography
                  sx={{
                    fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                    fontWeight: 800,
                    fontSize: '1.1rem',
                    color: GUOMEI.ink,
                    mb: 2,
                  }}
                >
                  {method.name}
                </Typography>
                <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                  {method.fields.map((field) => {
                    const key = `${method.id}-${field.label}`;
                    const isCopied = copiedKey === key;
                    return (
                      <Box
                        key={key}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        px={1.75}
                        py={1.25}
                        borderRadius={1.5}
                        bgcolor={GUOMEI.white}
                        border={`1px solid ${isCopied ? GUOMEI.lagoon : GUOMEI.sandDeep}`}
                        sx={{ gap: 1.5 }}
                      >
                        <Box minWidth={0} flex={1}>
                          <Typography
                            sx={{
                              fontSize: '0.7rem',
                              fontWeight: 700,
                              letterSpacing: '0.06em',
                              textTransform: 'uppercase',
                              color: GUOMEI.lagoon,
                              mb: 0.25,
                            }}
                          >
                            {field.label}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                              fontWeight: 600,
                              fontSize: '1.02rem',
                              color: GUOMEI.ink,
                              wordBreak: 'break-word',
                            }}
                          >
                            {field.value}
                          </Typography>
                        </Box>
                        <Button
                          type="button"
                          size="small"
                          variant={isCopied ? 'contained' : 'outlined'}
                          startIcon={isCopied ? <CheckIcon /> : <FileCopyOutlinedIcon />}
                          onClick={() => handleCopy(key, field.value)}
                          sx={{
                            flexShrink: 0,
                            borderRadius: 1.25,
                            fontWeight: 800,
                            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                            textTransform: 'none',
                            px: 1.75,
                            borderColor: GUOMEI.lagoon,
                            color: isCopied ? GUOMEI.white : GUOMEI.lagoon,
                            bgcolor: isCopied ? GUOMEI.lagoon : 'transparent',
                            '&:hover': {
                              borderColor: GUOMEI.ocean,
                              bgcolor: isCopied ? GUOMEI.ocean : GUOMEI.sand,
                              color: isCopied ? GUOMEI.white : GUOMEI.ocean,
                            },
                          }}
                        >
                          {isCopied ? 'Copiado' : 'Copiar'}
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Payment;
